import { normalizeTextForMatch } from "@ryde/shared";

import { IBulkActionItem } from "./bulk-actions.models";

/**
 * Filters bulk actions by the panel search box. Both the label and the hint are searched,
 * so typing "gps" finds "Get History GPS data" even when the wording differs.
 */
export const filterBulkActions = (
  actions: IBulkActionItem[],
  searchValue: string,
): IBulkActionItem[] => {
  const normalizedSearchValue = normalizeTextForMatch(searchValue);

  if (!normalizedSearchValue) {
    return actions;
  }

  return actions.filter(({ label, hint }) =>
    normalizeTextForMatch(`${label} ${hint ?? ""}`).includes(
      normalizedSearchValue,
    ),
  );
};
